import { defineMessages } from 'react-intl';

export default defineMessages({
  dealerInvoiceNumber: {
    id: 'OrderFulfillmentView.ItemGrid.StatusChange.dealerInvoiceNumber',
    defaultMessage: 'Dealer Invoice Number'
  },
  creditPurchaseOrderNumber: {
    id: 'ReturnsOrderViewSection.ReturnCard.StatusChange.purchaseOrderNumber',
    defaultMessage: 'Purchase Order Number for Return Credit'
  },
  creditDealerInvoiceNumber: {
    id: 'ReturnsOrderViewSection.ReturnCard.StatusChange.dealerInvoiceNumber',
    defaultMessage: 'Dealer Invoice Number for Return Credit'
  },
  purchaseOrderNumber: {
    id: 'OrderFulfillmentView.ItemGrid.StatusChange.purchaseOrderNumber',
    defaultMessage: 'Purchase Order Number'
  },
  taxOverride: {
    id: 'OrderFulfillmentView.ItemGrid.StatusChange.taxOverride',
    defaultMessage: 'Tax Override'
  }
});
